import React, { useState, useCallback } from 'react';
import { getTranslatedText } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { omit } from 'lodash';
import { Page, Heading, ChoiceList, Banner } from '@superops/ui-design-system';
import { useChatFeatureEnabled } from '@nile/components/src/Pages/SystemTrayChatPage/utils';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { VISIBILITY_OPTIONS } from '../../Constants/clientVisibility';
import AssociateClients from './AssociateClients';
import AssociatedClientsList from './AssociatedClientsList';

// TODO - Heading margin standardisation
// TODO - Choice list items line height standardisation
// TODO - Plain button padding, margin standardisation

/**
 * We have this styled component to override the styles of above polaris components
 */

function ClientVisibility(props) {
  const { intl, clientList, updateParent, data } = props;
  const flags = useFlags();
  const { clientVisibility } = data;
  const choiceList = VISIBILITY_OPTIONS.map((el) => {
    return {
      ...el,
      label: getTranslatedText(intl, el.label)
    };
  });

  const isChatAvailable = useChatFeatureEnabled();
  const [selectedOption, setSelectedOption] = useState([
    choiceList.find((el) => el.name === clientVisibility).name
  ]);

  const handleChange = useCallback((option) => {
    if (
      data?.hasOwnProperty('allowDeleteOrClientVisibilityUpdate') &&
      !data?.allowDeleteOrClientVisibilityUpdate
    )
      return;
    setSelectedOption(option);
    updateParent('clientVisibility', option[0]);
  }, []);
  const updateClientList = (items) => {
    const selectedItems = items.map((el) => {
      return omit(el, ['label', 'id']);
    });
    updateParent('selectedClients', selectedItems);
  };
  return (
    <div className="page tab-page full-height">
      <Page variant="primary" contentHeight="100px">
        <div className="m16 client-visibility">
          {flags?.agentChatFe && isChatAvailable && (
            <div className="mbt5">
              <Banner status="info">
                {getTranslatedText(intl, 'msp.chat.ticketform.delete.tooltip')}
              </Banner>
            </div>
          )}
          <div className="mb10">
            <Heading element="h2">
              <FormattedMessage id="admin.customForms.steps.clientVisibility.heading" />
            </Heading>
          </div>
          <div className="mb10">
            <ChoiceList
              choices={choiceList}
              selected={selectedOption}
              onChange={handleChange}
            />
          </div>
          {selectedOption[0] === 'SPECIFIC' && (
            <AssociateClients
              intl={intl}
              clientList={clientList}
              updateClientList={updateClientList}
            />
          )}
          {clientList.length > 0 && selectedOption[0] === 'SPECIFIC' && (
            <AssociatedClientsList
              clientList={clientList}
              updateClientList={updateClientList}
            />
          )}
        </div>
      </Page>
    </div>
  );
}

export default injectIntl(ClientVisibility);
